import React from 'react';
import styled, { keyframes } from 'styled-components';
import tw from 'twin.macro';

const spin = keyframes`
    to { transform: rotate(360deg); }
`;

const Spinner = styled.div`
    ${tw`inline-block`}
    width: ${props => props.size || '40'}px;
    height: ${props => props.size || '40'}px;
    border: 4px solid rgba(10, 189, 25, 0.2);
    border-top-color: #0ABD19;
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;

const LoadingContainer = styled.div`
    ${tw`flex flex-col items-center justify-center`}
    ${props => props.fullScreen && tw`min-h-screen`}
    padding: ${props => props.padding || '40'}px;
`;

const LoadingText = styled.p`
    ${tw`mt-4 text-gray-600 text-center`}
`;

export const LoadingSpinner = ({ size, text, fullScreen, padding }) => (
    <LoadingContainer fullScreen={fullScreen} padding={padding}>
        <Spinner size={size} />
        {text && <LoadingText>{text}</LoadingText>}
    </LoadingContainer>
);

// Inline загрузка (для кнопок)
export const InlineSpinner = styled.div`
    ${tw`inline-block`}
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: ${spin} 0.6s linear infinite;
    margin-right: 8px;
    vertical-align: middle;
`;

// Оверлей загрузка (поверх контента)
export const LoadingOverlay = ({ text }) => (
    <OverlayContainer>
        <OverlayContent>
            <Spinner size={50} />
            {text && <LoadingText style={{ color: 'white' }}>{text}</LoadingText>}
        </OverlayContent>
    </OverlayContainer>
);

const OverlayContainer = styled.div`
    ${tw`fixed inset-0 flex items-center justify-center`}
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
`;

const OverlayContent = styled.div`
    ${tw`bg-white rounded-lg p-8 shadow-2xl`}
    min-width: 200px;
`;

export default LoadingSpinner;